import * as Types from '../../../graphql/__generated__/globalTypes';

import { gql } from '@apollo/client';
import { WorkOrdersTableColumnFragmentDoc } from '../../PaymentsPage/summaries/WorkOrdersTable/__generated__/WorkOrdersTableColumns.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ListJobsForTableQueryVariables = Types.Exact<{
  input: Types.ListJobsInput;
}>;


export type ListJobsForTableQuery = { __typename?: 'Query', listJobsForTable: { __typename?: 'JobListForTableReturn', count: number, offset?: number | null, items: Array<{ __typename?: 'JobForTable', jobMetadata: { __typename?: 'JobForTableMetadata', id: string, deletedAt?: any | null, jobNumber: number, totalPaid?: number | null, createdAt: any, mechanicShopStatus?: Types.JobMechanicShopStatus | null, workOrderId: string, timeKeysReceived?: any | null, timeCompleted?: any | null, timePickedUp?: any | null, carOdometer?: number | null }, customer?: { __typename?: 'CustomerForTable', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, createdAt: any, secondaryPhoneNumber?: string | null, companyName?: string | null } | null, car?: { __typename?: 'CarForTable', id: string, make?: string | null, model?: string | null, year?: number | null, colour?: string | null, createdAt: any, vin?: string | null, licensePlate?: string | null } | null, invoice?: { __typename?: 'InvoiceForTable', remainingWithCreditCardFeesRecoup: number, approvedOn?: any | null } | null, appointment?: { __typename?: 'AppointmentForTable', id: string, expectedDropoffTime?: any | null } | null }> } };


export const ListJobsForTableDocument = gql`
    query ListJobsForTable($input: ListJobsInput!) {
  listJobsForTable(input: $input) {
    items {
      ...WorkOrdersTableColumn
      jobMetadata {
        id
        deletedAt
        jobNumber
        totalPaid
        createdAt
        mechanicShopStatus
      }
      customer {
        id
        firstName
        lastName
        email
        phoneNumber
      }
      car {
        id
        make
        model
        year
        colour
      }
    }
    count
    offset
  }
}
    ${WorkOrdersTableColumnFragmentDoc}`;

/**
 * __useListJobsForTableQuery__
 *
 * To run a query within a React component, call `useListJobsForTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useListJobsForTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListJobsForTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListJobsForTableQuery(baseOptions: Apollo.QueryHookOptions<ListJobsForTableQuery, ListJobsForTableQueryVariables> & ({ variables: ListJobsForTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListJobsForTableQuery, ListJobsForTableQueryVariables>(ListJobsForTableDocument, options);
      }
export function useListJobsForTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListJobsForTableQuery, ListJobsForTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListJobsForTableQuery, ListJobsForTableQueryVariables>(ListJobsForTableDocument, options);
        }
export function useListJobsForTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListJobsForTableQuery, ListJobsForTableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListJobsForTableQuery, ListJobsForTableQueryVariables>(ListJobsForTableDocument, options);
        }
export type ListJobsForTableQueryHookResult = ReturnType<typeof useListJobsForTableQuery>;
export type ListJobsForTableLazyQueryHookResult = ReturnType<typeof useListJobsForTableLazyQuery>;
export type ListJobsForTableSuspenseQueryHookResult = ReturnType<typeof useListJobsForTableSuspenseQuery>;
export type ListJobsForTableQueryResult = Apollo.QueryResult<ListJobsForTableQuery, ListJobsForTableQueryVariables>;